<template>
  <div class="request-contact-info-main-section mt-4">
    <section-title content="Información de Contacto" :has-line="true" />
    <div class="px-4 pb-4">
      <div class="row mt-4">
        <div class="col-md">
          <label class="data-title mb-n3">Nombre:</label>
          <span v-if="isReadOnly" class="data-content d-block">
            {{ model.contactName | empty }}
          </span>
          <custom-input
            v-else
            v-model="model.contactName"
            :disabled="isReadOnly"
          />
        </div>
        <div class="col-md">
          <validation-provider
            v-slot="{ errors, failedRules }"
            name="email1"
            :rules="{ required: true, email: true, excludeDomainDePrGov: true }"
          >
            <label class="data-title mb-n2">Correo Electrónico:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.email | empty }}
            </span>
            <custom-input
              v-else
              v-model="model.email"
              :custom-error-msg="customErrorMsg(failedRules)"
              :disabled="isReadOnly"
              :error="errors[0]"
              type="email"
            />
          </validation-provider>
        </div>
        <div class="col-md">
          <validation-provider
            ref="cellPhone"
            v-slot="{ errors }"
            mode="eager"
            name="cellPhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-n2">Teléfono Celular:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.cellPhone | phone }}
            </span>
            <custom-input
              v-else
              v-model="model.cellPhone"
              :custom-error-msg="getCellPhoneErrorMsg"
              :disabled="isReadOnly"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <validation-provider
            ref="homePhone"
            v-slot="{ errors }"
            mode="passive"
            name="homePhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-n2">Teléfono Hogar:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.homePhone | phone }}
            </span>
            <custom-input
              v-else
              v-model="model.homePhone"
              :custom-error-msg="getHomePhoneErrorMsg"
              :disabled="isReadOnly"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>

        <div class="col-md-4">
          <validation-provider
            ref="workPhone"
            v-slot="{ errors }"
            mode="passive"
            name="workPhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-n2">Teléfono Trabajo:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.workPhone | phone }}
            </span>
            <custom-input
              v-else
              v-model="model.workPhone"
              :custom-error-msg="getWorkPhoneErrorMsg"
              :disabled="isReadOnly"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>

        <div class="col-md-2">
          <label class="data-title mb-n2">Ext:</label>
          <span v-if="isReadOnly" class="data-content d-block">
            {{ model.extension | empty }}
          </span>
          <custom-input
            v-else
            v-model="model.extension"
            :disabled="isReadOnly"
            type="number"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import SectionTitle from 'SectionTitle';

import { ValidationProvider } from 'vee-validate';

export default {
  name: 'RequestContactInfo',
  components: {
    CustomInput,
    SectionTitle,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    getWorkPhoneErrorMsg() {
      if (!this.model.workPhone) return 'El teléfono trabajo es requerido.';
      return 'El campo es requerido.';
    },
    getHomePhoneErrorMsg() {
      if (!this.model.homePhone) return 'El teléfono del hogar es requerido.';
      return 'El campo es requerido.';
    },
    getCellPhoneErrorMsg() {
      if (!this.model.cellPhone) return 'El teléfono celular es requerido.';
      return 'El campo es requerido.';
    },
    isSomePhoneFilledUp() {
      const cell = Boolean(this.model.cellPhone);
      const home = Boolean(this.model.homePhone);
      const work = Boolean(this.model.workPhone);
      return cell || home || work;
    },
  },
  methods: {
    customErrorMsg(failedRules) {
      if (failedRules['excludeDomainDePrGov']) {
        return failedRules['excludeDomainDePrGov'];
      }

      if (failedRules['email']) {
        return 'El correo electrónico no es válido.';
      }

      return 'El correo electrónico es requerido.';
    },
    validateField() {
      if (!this.isSomePhoneFilledUp) {
        this.$refs['cellPhone'].reset();
        this.$refs['homePhone'].reset();
        this.$refs['workPhone'].reset();
      }
    },
  },
};
</script>
